<template>  
  <card-seplag> 
    <div class="p-grid p-col-12" style="margin-top:10px;">
        <div class="p-md-6 p-col-12">
            <Card class="card-button estiloPendentes">
                <template slot="content">    
                    <div class="p-grid">
                        <div class="p-col-7">
                            <span class="botao-titulo-status">Pendentes</span>
                        </div>
                    </div>                    
                </template>
            </Card>
        </div>       
        <div class="p-md-6 p-col-12"  @click="irParaValidados">
            <Card class="card-button">     
                <template slot="content">    
                    <div class="p-grid">
                        <div class="p-col-7">
                            <span class="botao-titulo-status">Validados</span>
                        </div>
                    </div>                    
                </template>
            </Card>
        </div>  
    </div>
    <div class="p-grid p-col-12" style="margin-top:10px;">
        <Rotulo cols="12 3" nome="Setor:">
            <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
                placeholder="Selecione..." filter :disabled="false" @change="carregarDados()" />                
        </Rotulo>
    </div>
    <div class="p-grid p-col-12" style="margin-top:10px;">        
        <h1 class="p-col-12">Licenças Pendentes de Validação</h1>
        <table-seplag 
            :dados="dadosTabelaPendentes" 
            :exibirCabecalho="false" 
            :paginacao="true"
            :campos="[]"
            :onSearchPaginacao="carregarDados" 
            :totalRegistro="totalRegistro">
            <Column field="matricula" header="Matrícula" :headerStyle="`width: 3%;`"></Column>
            <Column header="Servidor" headerStyle="width: 14em; justify-content: center; "  bodyStyle="text-align: center;">
                <template #body="slotProps">
                    {{ slotProps.data.nome? slotProps.data.nome : ""}}<br>
                    <span><strong>{{slotProps.data.setor? slotProps.data.setor : ""}}</strong></span>
                </template>
            </Column>
            <Column header="Período de Aquisitivo" headerStyle="width: 14em"  bodyStyle="text-align: center;">
                <template #body="slotProps">
                    {{slotProps.data.dataInicioPeraq? slotProps.data.dataInicioPeraq+" à "+slotProps.data.dataFimPeraq : ""}}
                </template>
            </Column>
            <Column  headerStyle="width: 14em" bodyStyle="text-align: center" header="Período de Usufruto">
                <template  #body="slotProps"> 
                        <span>{{slotProps.data.dataInicio}} à {{slotProps.data.dataFim}}</span><br>                   
                        <span v-if="slotProps.data.dataInicioTemporario">Alterado para {{slotProps.data.dataInicioTemporario}} à {{slotProps.data.dataFimTemporario}}</span>
                    </template>
            </Column>
            <Column  headerStyle="width: 10em; text-align: center" header="Dias de Afastamento">
                <template #body="slotProps"> 
                    <div style="text-align: center;">
                        <span>{{slotProps.data.totalDias? slotProps.data.totalDias: "" }} dias <br></span>                       
                        <span v-if="slotProps.data.periodoJornadaReduzida">(<b>Redução de Jornada</b>)</span>
                        <span v-else >(<b>Usufruto</b>)</span><br>
                        <span><b>{{slotProps.data.tipoPedido? slotProps.data.tipoPedido : ""}}</b></span>
                    </div>
                </template>
            </Column>
            <Column headerStyle="width: 9em" bodyStyle="text-align: center" header="Status">
                    <template #body="slotProps">                                             
                            <span class="customer-badge-pendente">{{ slotProps.data.statusPortal }}</span>
                    </template>
            </Column>
                    
            <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação">
                
                <template #body="slotProps">                        
                        <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Aprovação'" @click="showModal(slotProps.data)" :disabled="slotProps.data.situacao=='ENCERRADO'" />
                </template>
            </Column>                
        </table-seplag>   
    </div>        
    <cadastro-rapido tamanhoTela="40rem" tituloTela="Aprovação" v-model="exibirTela" :modoEdicao="modoEdicao"  :onAdicionar="validaRegistro" :onfecharModal="fecharModalValidaEscala" optionValue="code" :textoButton="'Salvar'">
        <div class="p-col-12">
            <Fieldset v-if="dadosAprovacao">
                <template #legend>
                    <strong>Servidor</strong>
                </template>
                <p><strong>Matricula: </strong> {{dadosAprovacao.matricula?dadosAprovacao.matricula : ""}} - <strong>Vinculo: </strong> {{dadosAprovacao.numeroVinculo?dadosAprovacao.numeroVinculo : ""}}</p>
                <p><strong>Candidato: </strong> {{dadosAprovacao.nome?dadosAprovacao.nome : ""}}</p>
                <p><strong>Periodo de Usufruto: </strong> {{dadosAprovacao.dataInicio?dadosAprovacao.dataInicio : ""}} à {{dadosAprovacao.dataFim?dadosAprovacao.dataFim : ""}} </p>
                <p v-if="dadosAprovacao.dataInicioTemporario"><strong>Alterado para </strong>{{dadosAprovacao.dataInicioTemporario}} à {{dadosAprovacao.dataFimTemporario}}</p>
            </Fieldset>
        </div>
        <Rotulo nome="Deferido" cols="12" >
            <SelectButton name='deferido' v-model="registro.statusProgramacao" :options="simNao" optionLabel="name" optionValue="code" v-required />
        </Rotulo>
        <Rotulo nome="Motivo Rejeição:" cols="12" v-if="registro.statusProgramacao == 'N'" >
            <Dropdown name='motivoRejeicao' v-model="registro.motivoRejeicao" :options="motivoRejeicao" v-required />
        </Rotulo>
        <Rotulo nome="Justificativa:" cols="12" >
            <Textarea v-model="registro.obs"  rows="5" cols="30" />
        </Rotulo>
    </cadastro-rapido>
  </card-seplag>
</template>

<script>

import CardSeplag from '@/template/CardSeplag.vue'
import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import TableSeplag from '@/template/TableSeplag.vue'
import { simNao } from '@/config/global'
import { baseApiUrl } from '@/config/global'

const getDefaultState = () => {
    return {  
        matriculaValidador:  null,
        numeroVinculoValidador: null,
        idRegPubl:  null,
        proximaSituacao:  null,
        chaveperaqlesp:  null,
        motivoRejeicao:  null,
        chavePend:  null,
        obs:  null,
        statusProgramacao: null,

    }
}

export default {
    name:"ChefiaPendentesLicenca",
    components: { CardSeplag, CadastroRapido, Rotulo,TableSeplag },    
    data (){
        return{   
            simNao: simNao,
            dadosTabelaPendentes: [],
            dadosAprovacao: null,
            motivoRejeicao: [],
            totalRegistro: 0,            
            tamanhoPorpagina: 10,
            modoEdicao: 'adicionar',  
            registro: getDefaultState(),
            habilitaAgendamento: true,  
            exibirTela: false,
            listaUnidades: null,
            unidadeSelecionada: null,
        }
    },                   
methods: {
        async carregarDados() {
            try {
                const matricula = this.$store.getters.getMatricula
                const vinculo = this.$store.getters.getVinculo
                const urlPaginacao = `lincencaview/chefia/lista/${matricula}/${vinculo}/PENDENTE`

                // Buscar unidades
                await this.$http.get(`${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${matricula}/${vinculo}`).then(respUnidades => {                    
                    this.listaUnidades = respUnidades.data.map(function (element) {
                        return {
                            ...element,
                            labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
                        };
                    });
                    
                })
                

                this.unidadeSelecionada = this.unidadeSelecionada ? this.unidadeSelecionada : this.listaUnidades[0]

                // Buscar licenças
                await this.$http.get(`${baseApiUrl}/${urlPaginacao}/${this.unidadeSelecionada.codgSeap}?size=${this.tamanhoPorpagina}&page=0`).then(respLicencas =>{
                    this.dadosTabelaPendentes = respLicencas.data.content
                    this.totalRegistro = respLicencas.data.totalElements
                })
                

                // Buscar motivos de rejeição
                await this.$http.get(`${baseApiUrl}/lincencaview/validar/motivo/rejeicao`).then(respMotivos=>{
                    this.motivoRejeicao = respMotivos.data
                })
                
            } catch (err) {
                console.error("Erro ao carregar dados:", err)
            }
        },
        fecharModalValidaEscala(){           
            this.registro = getDefaultState(); 
            this.dadosAprovacao = null
            this.exibirTela = false
        },

        showModal(dados){
            this.registro.matriculaValidador = this.$store.getters.getMatricula
            this.registro.numeroVinculoValidador = this.$store.getters.getVinculo
            this.registro.idRegPubl = dados.idRegPubl
            this.registro.proximaSituacao = null
            this.registro.chaveperaqlesp = dados.chaveperaqlesp
            this.registro.chavePend = dados.chavePend
            this.dadosAprovacao = dados
            this.exibirTela = true
        },
        validaRegistro(){ 

            if(this.registro.statusProgramacao == 'N' && !this.registro.motivoRejeicao){
                this.$toast.add({severity: 'error', summary: 'Erro', detail: 'Informe o motivo da rejeição'})
                return
            }
            if(this.registro.statusProgramacao == 'N' && !this.registro.obs){
                this.$toast.add({severity: 'error', summary: 'Erro', detail: 'A justificativa é OBRIGATORIA quando o pedido de Licença for negado'})
                return

            }
            if(this.registro.statusProgramacao=='N'){
                this.registro.proximaSituacao = 'REJEITADO'
            }else{
                this.registro.proximaSituacao = 'AUTORIZADO'
            }
            this.$http.post(`${baseApiUrl}/lincencaview/validarRejeitarLicenca`, JSON.stringify(this.registro)).then(() => {
                this.$toast.add({severity: 'success', summary: 'Sucesso', detail: 'Registro validado com sucesso'})
                this.fecharModalValidaEscala()
                this.carregarDados()
            })
        },
        irParaValidados(){
            this.$router.push({name: 'ChefiaValidadosLicenca'})
        }
    },
    mounted(){
		// Carrega os dados do serviço
		this.carregarDados()
    }
}

</script>

<style scoped>

.estiloPendentes {
  background: rgb(219, 171, 81);
  color: aliceblue;
}

.card-button{    
    cursor: pointer;
}

.botao-titulo-status{    
    font-size: 15px;
    font-weight: bold;
}

.customer-badge-pendente {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color:  rgb(219, 171, 81);
    color: aliceblue;
}

</style>